/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './tenant-gateway-transaction.reducer';

export const TenantGatewayTransaction = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const tenantGatewayTransactionList = useAppSelector(state => state.tenantGatewayTransaction.entities);
  const loading = useAppSelector(state => state.tenantGatewayTransaction.loading);
  const totalItems = useAppSelector(state => state.tenantGatewayTransaction.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="tenant-gateway-transaction-heading" data-cy="TenantGatewayTransactionHeading">
        <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.home.title">Tenant Gateway Transactions</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/tenant-gateway-transaction/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.home.createLabel">
              Create new Tenant Gateway Transaction
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.tenantGatewayTransaction.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {tenantGatewayTransactionList && tenantGatewayTransactionList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('success')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.success">Success</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('success')} />
                </th>
                <th className="hand" onClick={sort('code')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.code">Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('code')} />
                </th>
                <th className="hand" onClick={sort('message')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.message">Message</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('message')} />
                </th>
                <th className="hand" onClick={sort('transactionId')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.transactionId">Transaction Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('transactionId')} />
                </th>
                <th className="hand" onClick={sort('transactionType')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.transactionType">Transaction Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('transactionType')} />
                </th>
                <th className="hand" onClick={sort('merchantId')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.merchantId">Merchant Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('merchantId')} />
                </th>
                <th className="hand" onClick={sort('providerReferenceId')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.providerReferenceId">Provider Reference Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('providerReferenceId')} />
                </th>
                <th className="hand" onClick={sort('amount')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.amount">Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('amount')} />
                </th>
                <th className="hand" onClick={sort('payResponseCode')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.payResponseCode">Pay Response Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('payResponseCode')} />
                </th>
                <th className="hand" onClick={sort('trdPtyUtr')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.trdPtyUtr">Trd Pty Utr</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('trdPtyUtr')} />
                </th>
                <th className="hand" onClick={sort('qrCodeId')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.qrCodeId">Qr Code Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qrCodeId')} />
                </th>
                <th className="hand" onClick={sort('storeId')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.storeId">Store Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('storeId')} />
                </th>
                <th className="hand" onClick={sort('terminalId')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.terminalId">Terminal Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('terminalId')} />
                </th>
                <th className="hand" onClick={sort('userId')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.userId">User Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('userId')} />
                </th>
                <th className="hand" onClick={sort('gatewayResponse')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.gatewayResponse">Gateway Response</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gatewayResponse')} />
                </th>
                <th className="hand" onClick={sort('tenantId')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.tenantId">Tenant Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tenantId')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('draft')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.draft">Draft</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('draft')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('bankId')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.bankId">Bank Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bankId')} />
                </th>
                <th className="hand" onClick={sort('bankTransactionId')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.bankTransactionId">Bank Transaction Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bankTransactionId')} />
                </th>
                <th className="hand" onClick={sort('pgTransactionId')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.pgTransactionId">Pg Transaction Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pgTransactionId')} />
                </th>
                <th className="hand" onClick={sort('pgInstrumentType')}>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.pgInstrumentType">Pg Instrument Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pgInstrumentType')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.gateway">Gateway</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.paymentMode">Payment Mode</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.paymentState">Payment State</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {tenantGatewayTransactionList.map((tenantGatewayTransaction, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/tenant-gateway-transaction/${tenantGatewayTransaction.id}`} color="link" size="sm">
                      {tenantGatewayTransaction.id}
                    </Button>
                  </td>
                  <td>{tenantGatewayTransaction.success ? 'true' : 'false'}</td>
                  <td>{tenantGatewayTransaction.code}</td>
                  <td>{tenantGatewayTransaction.message}</td>
                  <td>{tenantGatewayTransaction.transactionId}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.TransactionCategory.${tenantGatewayTransaction.transactionType}`} />
                  </td>
                  <td>{tenantGatewayTransaction.merchantId}</td>
                  <td>{tenantGatewayTransaction.providerReferenceId}</td>
                  <td>{tenantGatewayTransaction.amount}</td>
                  <td>{tenantGatewayTransaction.payResponseCode}</td>
                  <td>{tenantGatewayTransaction.trdPtyUtr}</td>
                  <td>{tenantGatewayTransaction.qrCodeId}</td>
                  <td>{tenantGatewayTransaction.storeId}</td>
                  <td>{tenantGatewayTransaction.terminalId}</td>
                  <td>{tenantGatewayTransaction.userId}</td>
                  <td>{tenantGatewayTransaction.gatewayResponse}</td>
                  <td>{tenantGatewayTransaction.tenantId}</td>
                  <td>{tenantGatewayTransaction.active ? 'true' : 'false'}</td>
                  <td>{tenantGatewayTransaction.draft ? 'true' : 'false'}</td>
                  <td>{tenantGatewayTransaction.cursor}</td>
                  <td>{tenantGatewayTransaction.lastUpdated}</td>
                  <td>{tenantGatewayTransaction.microSec}</td>
                  <td>{tenantGatewayTransaction.timestampEntry}</td>
                  <td>{tenantGatewayTransaction.bankId}</td>
                  <td>{tenantGatewayTransaction.bankTransactionId}</td>
                  <td>{tenantGatewayTransaction.pgTransactionId}</td>
                  <td>{tenantGatewayTransaction.pgInstrumentType}</td>
                  <td>
                    {tenantGatewayTransaction.gateway ? (
                      <Link to={`/tenant-payment-gateway/${tenantGatewayTransaction.gateway.id}`}>
                        {tenantGatewayTransaction.gateway.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {tenantGatewayTransaction.paymentMode ? (
                      <Link to={`/clinical-dictionary/${tenantGatewayTransaction.paymentMode.id}`}>
                        {tenantGatewayTransaction.paymentMode.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {tenantGatewayTransaction.paymentState ? (
                      <Link to={`/clinical-dictionary/${tenantGatewayTransaction.paymentState.id}`}>
                        {tenantGatewayTransaction.paymentState.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/tenant-gateway-transaction/${tenantGatewayTransaction.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/tenant-gateway-transaction/${tenantGatewayTransaction.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/tenant-gateway-transaction/${tenantGatewayTransaction.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.tenantGatewayTransaction.home.notFound">
                No Tenant Gateway Transactions found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={tenantGatewayTransactionList && tenantGatewayTransactionList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default TenantGatewayTransaction;
